import Vue from 'vue';
import { MutationTree } from "vuex";
import { TrialPeriodState } from "@/types/store/clientzone/trial_period";
import { TrialPeriodData } from "@/types";

export const mutations: MutationTree<TrialPeriodState> = {
  SET_TRIAL_PERIOD: (state, payload: Array<TrialPeriodData>): Array<TrialPeriodData> => Vue.set(state, 'trialPeriod', payload),
}
